// lib/apiError.ts

/**
 * Turns a backend error into a user-friendly message. Detects duplicate-record
 * errors (e.g. a 500/409 from a unique constraint) and reports which field
 * clashed, so users see "Email already exists" instead of a raw server error.
 */
export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;

  const raw = [
    typeof data === "string" ? data : undefined,
    data?.message,
    data?.detail,
    typeof data?.error === "string" ? data.error : data?.error?.message,
    Array.isArray(data?.errors)
      ? data.errors.map((e: any) => e?.message || e).join(" ")
      : undefined,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  const has = (kw: string) => raw.includes(kw);

  const isDuplicate =
    error?.response?.status === 409 ||
    has("exist") ||
    has("already") ||
    has("duplicate") ||
    has("unique");

  if (isDuplicate) {
    if (has("email") || has("e-mail")) return "Email already exists";
    if (has("phone") || has("mobile") || has("contact"))
      return "Phone number already exists";
    if (has("roll")) return "Roll number already exists";
    return "This record already exists";
  }

  return data?.error?.message || data?.message || data?.detail || fallback;
};
